export default __webpack_public_path__ + "static/media/8.ca01ecca.jpg";